import { Component, OnInit, Input } from '@angular/core';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: August 10th 2018
 * 
 * Description: Component class for Portal Loader (Loading indicator) [shared]
 **/
@Component({
  selector: 'gosg-shared-loader',
  templateUrl: './portal-loader.component.html',
  styleUrls: ['./portal-loader.component.css']
})
export class SharedLoaderComponent implements OnInit {

  constructor() { }
  @Input() loader:boolean;
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/loader/shared-loader.component.ts